import { createActionCreator } from "common/ReduxUtils";
import { StorageDestinationActionTypes } from "../StorageDestinationAction.types";
import { StorageWarehouseSellerView } from "../StorageWarehouseSellerView";

export const setDestinationStorageWarehouse = createActionCreator<StorageWarehouseSellerView | undefined>(
  StorageDestinationActionTypes.STORAGE_SET_DESTINATION_WAREHOUSE,
  "destinationStorageWarehouse"
);
